import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import { FormattedPlural, FormattedMessage } from 'react-intl'
import arraySort from 'array-sort'

import CommentsList from '../mini/comments/CommentsList'
import DraftComment from '../mini/comments/DraftComment'

import { userDraftComments } from '../../selectors/userdraftcomments'
import {
  getFilteredComments,
  getResolvedComments,
  getTotalCommentCount,
  getUnresolvedCommentCount
} from '../../utils/comments'
import {
  addAComment,
  commentMessage,
  commentsMessage,
  hide,
  show,
  resolved
} from '../../utils/messages'
import { isUnixTimestamp } from '../../utils/time'

class Comments extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showDraftComment: props.userDraftComments.length > 0,
      showingResolvedComments: false,
      isNewDraft: false
    }

    this.onClickAddCommentBound = this.onClickAddComment.bind(this)
    this.toggleResolvedCommentsBound = this.toggleResolvedComments.bind(this)
    this.cancelDraftClickBound = this.cancelDraftClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userDraftComments.length > 0) {
      this.setState({ showDraftComment: true, isNewDraft: false })
    } else if (
      nextProps.userDraftComments.length === 0 &&
      !nextProps.isEditingComment
    ) {
      this.setState({ showDraftComment: false })
    }
    if (this.props.section !== nextProps.section) {
      this.setState({
        showDraftComment: nextProps.userDraftComments.length > 0
      })
    }
  }

  render() {
    const { user, userDraftComments, comments, section, activityId } =
      this.props
    const totalSectionCommentCount = getTotalCommentCount(
      comments,
      section,
      activityId
    )
    const unresolvedCommentCount = getUnresolvedCommentCount(
      comments,
      section,
      activityId
    )
    const resolvedComments = getResolvedComments(comments, section, activityId)
    const filteredComments = getFilteredComments(
      comments,
      section,
      activityId,
      this.state.showingResolvedComments
    )

    filteredComments.forEach(function (c) {
      isUnixTimestamp(c.updated_at)
        ? (c.updated_at_friendly = moment.unix(c.updated_at).valueOf())
        : (c.updated_at_friendly = moment(c.updated_at).valueOf())
    })

    return (
      <div className="comment-section">
        {!this.state.showDraftComment && (
          <div id="addACommentTriggerContainer">
            <hr />
            <div id="addACommentTrigger" onClick={this.onClickAddCommentBound}>
              {addAComment}
            </div>
          </div>
        )}
        <div
          className={`quest-comments ${
            totalSectionCommentCount > 0 ? '' : 'no-comments'
          }`}
        >
          {this.state.showDraftComment && (
            <DraftComment
              comment={
                this.state.isNewDraft
                  ? {
                      body: '',
                      user: user
                    }
                  : userDraftComments[0]
              }
              cancelDraftClick={this.cancelDraftClickBound}
              isNewDraft={this.state.isNewDraft}
              {...this.props}
            />
          )}
          <div className="published-comments">
            {totalSectionCommentCount > 0 && (
              <div id="commentCount">
                <div>{unresolvedCommentCount}</div>
                <div className="commenttext">
                  &nbsp;
                  <FormattedPlural
                    value={unresolvedCommentCount}
                    one={commentMessage}
                    other={commentsMessage}
                  />
                </div>
              </div>
            )}
            {resolvedComments.length > 0 && (
              <div id="commentStatusToggle">
                {this.state.showingResolvedComments && (
                  <div onClick={this.toggleResolvedCommentsBound}>
                    <div id="toggler"></div>
                    <label id="resolvedCommentCount">
                      <span>
                        <FormattedMessage
                          id={'Comments.HideComments'}
                          defaultMessage={
                            '{hide} {resolvedCount} {resolved} {comments}'
                          }
                          values={{
                            hide: hide,
                            resolvedCount: resolvedComments.length,
                            resolved: resolved,
                            comments: (
                              <FormattedPlural
                                value={resolvedComments.length}
                                one={commentMessage}
                                other={commentsMessage}
                              />
                            )
                          }}
                        />
                      </span>
                    </label>
                  </div>
                )}
                {!this.state.showingResolvedComments && (
                  <div onClick={this.toggleResolvedCommentsBound}>
                    <div id="toggler" className="show"></div>
                    <label id="resolvedCommentCount">
                      <span>
                        <FormattedMessage
                          id={'Comments.ShowComments'}
                          defaultMessage={
                            '{show} {resolvedCount} {resolved} {comments}'
                          }
                          values={{
                            show: show,
                            resolvedCount: resolvedComments.length,
                            resolved: resolved,
                            comments: (
                              <FormattedPlural
                                value={resolvedComments.length}
                                one={commentMessage}
                                other={commentsMessage}
                              />
                            )
                          }}
                        />
                      </span>
                    </label>
                  </div>
                )}
              </div>
            )}
            <CommentsList
              comments={arraySort(filteredComments, ['updated_at_friendly'], {
                reverse: true
              })}
              showingResolvedComments={this.state.showingResolvedComments}
              user={user}
              quest={this.props.quest}
              section={this.props.section}
              dispatch={this.props.dispatch}
            />
          </div>
        </div>
      </div>
    )
  }

  onClickAddComment() {
    this.setState({
      showDraftComment: !this.state.showDraftComment,
      isNewDraft: true
    })
  }

  toggleResolvedComments() {
    this.setState({
      showingResolvedComments: !this.state.showingResolvedComments
    })
  }

  cancelDraftClick() {
    this.setState(() => {
      return {
        showDraftComment: false
      }
    })
  }
}

Comments.propTypes = {
  dispatch: PropTypes.func,
  quest: PropTypes.object.isRequired,
  resourceId: PropTypes.number,
  activityId: PropTypes.number,
  comments: PropTypes.array,
  section: PropTypes.string,
  user: PropTypes.object,
  userDraftComments: PropTypes.array,
  isEditingComment: PropTypes.bool
}

const mapStateToProps = state => ({
  section: state.quest.section,
  activityId: state.quest.activityId,
  quest: state.quest,
  resourceId:
    state.quest.section !== 'activities'
      ? state.quest.item.id
      : state.quest.activityId,
  comments:
    state.quest.section !== 'activities'
      ? state.quest.comments
      : state.quest.activityComments,
  user: state.user.user,
  userDraftComments: userDraftComments(state),
  isEditingComment: state.quest.isEditingComment
})

export default connect(mapStateToProps)(Comments)
export { Comments as CommentsDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/Comments.js